import { render, staticRenderFns } from "./NewEndorsement.vue?vue&type=template&id=06484f69&scoped=true"
import script from "./NewEndorsement.vue?vue&type=script&lang=js"
export * from "./NewEndorsement.vue?vue&type=script&lang=js"
import style0 from "./NewEndorsement.vue?vue&type=style&index=0&id=06484f69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06484f69",
  null
  
)

export default component.exports